export default "__VITE_ASSET__DZxc$hYT__"